<template>
    <div>
        <div class="row mb-3">
            <search-bar v-model="searchString"
                        class="col-md-8"
                        placeholder="Nach Namen suchen ..."></search-bar>

            <div class="col-12 col-md-4 d-md-flex justify-content-end mb-5">
                <button v-if="!isNew"
                        class="btn btn-success w-100"
                        type="button" @click="isNew = true">Neu <i class="fas fa-plus"></i></button>
                <button v-if="isNew"
                        class="btn btn-danger w-100"
                        type="button" @click="isNew = false">Abbrechen <i class="fas fa-times"></i>
                </button>
            </div>
        </div>
        <transition mode="out-in" name="slide">
            <gallery-form v-if="isNew"
                          :national-service-options="this.nationalServiceOptions"
                          :url="this.url"
                          axios-method="POST"
                          @addItem="this.addItem"
                          @cancelNew="this.cancelNew"></gallery-form>
        </transition>

        <no-data v-if="hasNoData"></no-data>

        <loader v-if="!hasNoData && isLoading"></loader>

        <div v-if="!isLoading" class="row">

            <gallery v-for="(item, index) in filteredList"
                     :key="item.id"
                     :data-index="index"
                     :item="item"
                     :national-service-options="nationalServiceOptions"
                     @updateItems="updateItems"
                     @deleteItem="deleteItem"></gallery>
        </div>

    </div>
</template>

<script>

import Gallery from './Gallery';
import GalleryForm from './GalleryForm';

export default {
    name: 'Galleries',
    components: {GalleryForm, Gallery},
    data() {
        return {
            searchString: null,
            items: null,
            hasNoData: false,
            isLoading: true,
            isNew: false,
            url: '/api/merchant/galleries',
            nationalServiceOptions: null,
        };
    },

    created() {
        this.getGallery();
    },

    computed: {
        filteredList() {
            if (!this.searchString) {
                return this.items;
            }
            return this.items.filter(element => {
                return element.name.toLowerCase().includes(this.searchString.toLowerCase());
            });
        },
    },

    watch: {
        searchString(newValue) {
            this.searchString = newValue;
        },
    },

    methods: {
        updateItems(gallery) {
            let index = this.items.findIndex(item => item.id === gallery.id);

            if (index) {
                this.items[index] = gallery;
            }
        },

        cancelNew() {
            this.isNew = false;
        },

        deleteItem(payload) {
            this.items.forEach((element, index) => {
                if (element.id === payload) {
                    this.items.splice(index, 1);
                }
            });
        },

        addItem(payload) {
            this.items.unshift(payload);
            this.cancelNew();
        },

        getGallery() {
            const nationalServiceOptions = axios.get('/api/admin/national-services');
            const galleries = axios.get(this.url);

            axios.all([nationalServiceOptions, galleries]).then((responses) => {
                this.nationalServiceOptions = responses[0].data.data;
                this.items = responses[1].data.data;

                if (responses[0].data.data.length === 0 || responses[1].data.data.length === 0) {
                    this.hasNoData = true;
                }

                if (responses[0].data.data.length > 0 && responses[1].data.data.length > 0) {
                    this.isLoading = false;

                }
            }).catch((error) => {
                this.inputErrors = error.response.data.errors;
                this.$swal({
                    icon: 'error',
                    title: 'Es ist ein Fehler aufgetreten',
                });
                this.isLoading = false;
                this.hasNoData = true;
            });
        }
    },
};
</script>

<style scoped>

</style>
